'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = createMixins;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createMixins(breakpoints, palette, typography, variables) {
  var borderWidth = variables.borderWidthFocused - variables.borderWidth;

  return {
    /**
     * Global styles
     */
    global: function () {
      function global() {
        var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return Object.assign({}, styles, {
          html: {
            boxSizing: 'border-box',
            height: '100%'
          },
          '*, *:before, *:after': {
            boxSizing: 'inherit'
          },
          body: {
            margin: 0,
            height: '100%',
            backgroundColor: palette.background['default'],
            fontFamily: typography.fontFamily,
            color: palette.text.primary,
            lineHeight: typography.lineHeight,
            overflowX: 'hidden',
            WebkitFontSmoothing: 'antialiased', // Antialiasing.
            MozOsxFontSmoothing: 'grayscale' // Antialiasing.
          },
          a: {
            color: typography.highlight.color,
            outline: 'none',
            textDecoration: 'none',
            '&:focus, &:hover': {
              outline: 'none',
              textDecoration: 'none'
            }
          },
          /* Internet Explorer 10+ */
          '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
            '*, *:before, *:after': {
              transition: 'none !important'
            }
          }
        });
      }

      return global;
    }(),
    /**
     * Border styles
     */
    border: function () {
      function border() {
        var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return Object.assign({}, styles, {
          padding: variables.borderPaddingTopBottom + borderWidth + 'px ' + (variables.borderPaddingRightLeft + borderWidth) + 'px',
          borderWidth: variables.borderWidth,
          borderStyle: 'solid',
          borderColor: palette.forms.primary,
          borderRadius: variables.borderRadius
        });
      }

      return border;
    }(),
    borderDisabled: function () {
      function borderDisabled() {
        var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return Object.assign({}, styles, {
          borderStyle: 'dotted'
        });
      }

      return borderDisabled;
    }(),
    borderFocused: function () {
      function borderFocused() {
        var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return Object.assign({}, styles, {
          padding: variables.borderPaddingTopBottom + 'px ' + variables.borderPaddingRightLeft + 'px',
          borderWidth: variables.borderWidthFocused,
          borderColor: palette.forms.active
        });
      }

      return borderFocused;
    }(),
    borderError: function () {
      function borderError() {
        var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return Object.assign({}, styles, {
          borderColor: palette.text.error
        });
      }

      return borderError;
    }(),
    /**
     * Placeholder styles
     */
    placeholder: function () {
      function placeholder() {
        var placeholderStyles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var styles = Object.assign({}, placeholderStyles, {
          overflow: 'hidden',
          whiteSpace: 'nowrap'
        });

        return {
          '&::placeholder': Object.assign({}, styles),
          '&::-webkit-input-placeholder': Object.assign({}, styles),
          '&:-ms-input-placeholder': Object.assign({}, styles),
          '&::-ms-input-placeholder': Object.assign({}, styles),
          '&::-moz-placeholder': Object.assign({}, styles),
          '&:-moz-placeholder': Object.assign({}, styles)
        };
      }

      return placeholder;
    }(),
    /*
     * Gutters
     */
    gutters: function () {
      function gutters(units) {
        var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return Object.assign({}, styles, {
          paddingLeft: typography.rhythmByUnit(units),
          paddingRight: typography.rhythmByUnit(units)
        });
      }

      return gutters;
    }(),
    /*
     * Hide visually and from screen readers
     */
    hidden: function () {
      function hidden() {
        var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return Object.assign({}, styles, {
          display: 'none !important'
        });
      }

      return hidden;
    }(),
    /*
     * Hide only visually, but have it available for screen readers:
     * https://snook.ca/archives/html_and_css/hiding-content-for-accessibility
     *
     * 1. For long content, line feeds are not interpreted as spaces and small width
     *    causes content to wrap 1 word per line:
     *    https://medium.com/@jessebeach/beware-smushed-off-screen-accessible-text-5952a4c2cbfe
     */
    visuallyhidden: function () {
      function visuallyhidden() {
        var focusable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var styles = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return Object.assign({}, styles, {
          border: 0,
          clip: 'rect(0 0 0 0)',
          clipPath: 'inset(50%)',
          height: 1,
          margin: -1,
          overflow: 'hidden',
          padding: 0,
          position: 'absolute',
          width: 1,
          whiteSpace: 'nowrap' /* 1 */
        }, focusable && {
          '&:active, &:focus': {
            clip: 'auto',
            clipPath: 'none',
            height: 'auto',
            margin: 0,
            overflow: 'visible',
            position: 'static',
            width: 'auto',
            whiteSpace: 'inherit'
          }
        });
      }

      return visuallyhidden;
    }(),
    /*
     * Hide visually and from screen readers, but maintain layout
     */
    invisible: function () {
      function invisible() {
        var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return Object.assign({}, styles, {
          visibility: 'hidden'
        });
      }

      return invisible;
    }(),
    /*
     * Truncate single-line string with ellipsis
     */
    truncate: function () {
      function truncate() {
        var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return Object.assign({}, styles, {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap'
        });
      }

      return truncate;
    }(),
    /*
     * Skeleton styles
     */
    skeleton: function () {
      function skeleton() {
        var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return Object.assign({}, styles, {
          backgroundImage: 'linear-gradient(to right, #eee 8%, #ddd 18%, #eee 33%)',
          backgroundSize: '200vw 100vw',
          animationName: 'skeleton',
          animationDuration: '2s',
          animationTimingFunction: 'linear',
          animationDelay: '0s',
          animationIterationCount: 'infinite',
          animationDirection: 'normal',
          animationFillMode: 'forwards',
          animationPlayState: 'running'
        });
      }

      return skeleton;
    }(),
    skeletonRandom: function () {
      function skeletonRandom() {
        var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return [].concat(_toConsumableArray(Array(variables.skeletonCount))).reduce(function (style, value, index) {
          return Object.assign({}, style, _defineProperty({}, '&[data-skeleton="' + index + '"]', {
            '& $skeletonPrimary': {
              marginRight: Math.floor(Math.random() * 10) + 1 + '%' // Random percent between 1% and 10%
            },
            '& $skeletonSecondary': {
              marginRight: Math.floor(Math.random() * 15) + 11 + '%' // Random percent between 11% and 25%
            }
          }));
        }, styles);
      }

      return skeletonRandom;
    }()
  };
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/styles/mixins.js
// module id = 1329
// module chunks = 32